import React from "react"

import { Form, Formik } from "formik"

import { adminClient as client } from "src/urql-client"

import { gql, useMutation } from "hooks/urql"

import { handleFailure } from "components/Forms/Formik/hookComponents"
import ModalWithProvidedBody, { Footer } from "components/ModalWithProvidedBody"

export type ArchiveGroupModalProps = {
  studyGroupId: string
  message: string
  closeModal: VoidFunction
}

const ArchiveGroupModal: React.FC<ArchiveGroupModalProps> = ({
  studyGroupId,
  message,
  closeModal,
}) => {
  const [, runMutation]: any[] = useMutation(archiveGroupMutation, client)

  const handleSubmit = (values, actions) => {
    runMutation(values)
      .then(
        result => {
          const { failures } = result.data.archiveStudyGroup
          if (failures.length > 0) handleFailure(actions, failures)
          else window.location.reload()
        },
        () => handleFailure(actions)
      )
      .catch(() => handleFailure(actions))
  }

  if (!message) return null

  return (
    <ModalWithProvidedBody
      modalTitle="Archive Study Group"
      isOpen={!!studyGroupId}
      hideTrigger
      closeModal={closeModal}
    >
      <Formik initialValues={{ studyGroupId }} onSubmit={handleSubmit}>
        <Form>
          <div className="modal-body">{message}</div>

          <Footer
            cancelAction={closeModal}
            isDangerous
            submitText="Yes, Archive"
            cancelText="No, Keep Group"
          />
        </Form>
      </Formik>
    </ModalWithProvidedBody>
  )
}

const archiveGroupMutation = gql`
  mutation ArchiveStudyGroup($studyGroupId: ID!) {
    archiveStudyGroup(studyGroupId: $studyGroupId) {
      failures {
        message
      }
    }
  }
`

export default ArchiveGroupModal
